export enum SubMenu {
  Priority = 'priority',
  LinkedItem = 'linked-item',
  DeadlineDeadline = 'deadline-deadline',
  ReminderTime = 'reminder-time',
  Date = 'date',
  SelectDate = 'select-date',
  Tags = 'tags',
  Timeslot = 'timeslot',
}
